import { Pagination } from 'antd';
import React from 'react';

const PaginationFooter = ({
  currentPage,
  pageSize,
  total,
  onChange,
  pageSizeOptions,
}) => {
  return (
    <div
      style={{
        padding: '8px',
        borderTop: '1px solid #f0f0f0',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={total}
        size="small"
        onChange={onChange}
        onShowSizeChange={onChange}
        showSizeChanger
        showTotal={(total, range) =>
          `${range[0]}-${range[1]} sur ${total} médias`
        }
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
};

export default PaginationFooter;
